import {
  type AppTemplate,
  DevelopmentTool,
} from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { TEMPLATE_TABS } from '../../constants/sideBarItems';
import type { TemplateTab } from '../../types/TemplateTabs';

interface GetTemplatesTabsToDisplayProps {
  filterByTab?: TemplateTab;
}

export const getTemplatesTabsToDisplay = ({
  filterByTab,
}: GetTemplatesTabsToDisplayProps): TemplateTab[] => {
  if (filterByTab && TEMPLATE_TABS.includes(filterByTab as DevelopmentTool)) {
    return [filterByTab];
  }
  return TEMPLATE_TABS;
};

interface GetTemplateForTabProps {
  templates: AppTemplate[];
  tab: TemplateTab;
}

export const getTemplatesForTab = ({
  templates,
  tab,
}: GetTemplateForTabProps): AppTemplate[] => {
  return templates.filter(
    (template) => !!template.developmentTools?.includes(tab as DevelopmentTool),
  );
};

export const isCliScratchTemplate = (template: AppTemplate): boolean => {
  return (
    !template.previewUrl &&
    template.developmentTools?.includes(DevelopmentTool.CLI)
  );
};

export const isBlocksScratchTemplate = (template: AppTemplate): boolean => {
  return (
    !template.previewUrl &&
    template.developmentTools?.includes(DevelopmentTool.BLOCKS)
  );
};

export const isSelfHostedScratchTemplate = (template: AppTemplate): boolean => {
  return (
    !template.previewUrl &&
    template.developmentTools?.includes(DevelopmentTool.DEV_CENTER)
  );
};
